<template>
  <div class="confirmLoan orderInfo">
    <!-- 主要内容 -->
    <div class="mainContent">
      <!-- 选择贷款额度 -->
      <div class="container">
        <div class="change_limit_con">
          <div class="orderNesc">
            <div class="orderMerchant">
              <img class="orderMerchantImg" :src="order.logo" alt=""/>
              <div class="orderMerchantName">{{ order.mchName }}</div>
            </div>
            <div class="orderDetail">
              <Icon class="orderDetail_icon" name="arrow"/>

              <div class="orderItem">
                <!--                  <div class="orderTitle">{{ l.o_item_status }}:</div>-->
                <div
                    class="orderStatus"
                    :class="[
              [
                [1, 4, 7].includes(orderStatusIndex) && 'red',
                orderStatusIndex == 5 && 'green',
              ],
            ]"
                >
                  {{
                    loanOverdueDay ? l.home_Overdue_day + loanOverdueDay + l.home_unit_day : orderStatus[orderStatusIndex]
                  }}
                </div>
              </div>
            </div>
          </div>
          <!--          <img class="applyImg" src="@/assets/home/apply.png" alt="" />-->
          <!-- backgroundImage: `url(${backgroundImgs[backgroundImgsIndex]})`, -->
          <div class="order_header_box">
            <div class="order_header_box_item">
              <div class="order_title">{{ loanTitle }}</div>
              <div class="order_amount" :class="isRed && 'redColor'">
                NT$ {{ formatMoney(loanNumber) }}
              </div>
            </div>
            <div class="order_header_box_item" v-if="applyTime">
              <div class="order_title">{{ l.o_item_application_time }}</div>
              <div class="order_amount" :class="isRed && 'redColor'">
                {{ applyTime }}
              </div>
            </div>
            <div class="order_header_box_item" v-if="processingDate">
              <div class="order_title">{{ l.o_details_application_time }}</div>
              <div class="order_amount" :class="isRed && 'redColor'">
                {{ processingDate }}
              </div>
            </div>
            <div class="order_header_box_item" v-else-if="overdueTime">
              <div class="order_title">{{ l.o_item_expire_dead_date }}</div>
              <div class="order_amount" :class="isRed && 'redColor'">
                {{ overdueTime }}
              </div>
            </div>
          </div>
          <div class="button_font_box">
            <Button
                v-if="isShowBtnConfirm && order.repaymentTypes.includes('rollover')"
                size="normal"
                type="info"
                block
                class="button_font"
                @click="handleRepaymentBtn(2)"
            >{{ l.o_details_rollver_submit_btn }}
            </Button>
            <div v-if="isShowBtnConfirm" style="width: 20px;"></div>
            <Button
                v-if="isShowBtnConfirm && order.repaymentTypes.includes('normal')"
                size="normal"
                type="info"
                block
                class="button_font"
                @click="handleRepaymentBtn(1)"
            >{{ l.o_details_submit_btn }}
            </Button>
            <!--            @click="openRepayModal"-->

            <Button
                v-if="isShowBtnConfirm2"
                size="normal"
                type="info"
                block
                class="button_font"
                @click="handleBorrowAnotherStroke"
            >{{ l.o_apply_again }}
            </Button>
          </div>
          <!--          <div class="order_desc" :class="orderDescIndex == 'fkz' && 'fkz'">-->
          <!--            {{ orderDesc[orderDescIndex] }}-->
          <!--          </div>-->
          <!--          <div class="order_desc_bgc"></div>-->
          <!--          <div-->
          <!--            class="order_status"-->
          <!--            :class="[-->
          <!--              [-->
          <!--                [1, 4, 7].includes(orderStatusIndex) && 'red',-->
          <!--                orderStatusIndex == 5 && 'green',-->
          <!--              ],-->
          <!--            ]"-->
          <!--          >-->
          <!--            {{ orderStatus[orderStatusIndex] }}-->
          <!--          </div>-->
        </div>
      </div>
      <div v-if="!isShowBtnConfirm" class="orderInfo_round_box"></div>
      <div v-if="!isShowBtnConfirm" class="container_info container_info_middle">
        <div class="info_footer">
          <div class="footer_item" v-if="payAmount">
            <div class="footer_title">{{ l.home_payment_fee }}</div>
            <div class="footer_desc">NT${{ formatMoney(payAmount) }}</div>
          </div>
          <div class="footer_item" v-if="serviceAmount">
            <div class="footer_title">{{ l.home_audit_consultation_fee }}</div>
            <div class="footer_desc">NT${{ formatMoney(serviceAmount) }}</div>
          </div>
          <div class="footer_item" v-if="riskAmount">
            <div class="footer_title">{{ l.home_handling_fee }}</div>
            <div class="footer_desc">NT${{ formatMoney(riskAmount) }}</div>
          </div>
        </div>
      </div>
      <div v-if="orderStatusIndex == 7" class="orderInfo_round_box"></div>
      <div v-if="orderStatusIndex == 7" class="container_info container_info_middle">
        <div class="info_footer">
          <div class="footer_item" v-if="loanFaleFee">
            <div class="footer_title">{{ l.o_item_lagfall_fee }}</div>
            <div class="footer_desc footer_desc_red">NT${{ formatMoney(loanFaleFee) }}</div>
          </div>
          <div class="footer_item" v-if="loanOverdueFee">
            <div class="footer_title">{{ l.o_item_overdue_fee }}</div>
            <div class="footer_desc footer_desc_red">NT${{ formatMoney(loanOverdueFee) }}</div>
          </div>

        </div>
      </div>

      <div class="orderInfo_round_box"></div>
      <!-- <div class="container_info" v-if="false"> -->
      <div class="container_info">
        <div class="info_footer">
          <div class="footer_item" v-if="loanAmount">
            <div class="footer_title">{{ l.o_loan_loan_amounts }}</div>
            <div class="footer_desc">NT${{ loanAmount }}</div>
          </div>
          <div
              class="footer_item"
              v-if="totalAmount && !['wyqhk', 'yqhk'].includes(orderDescIndex)"
          >
            <div class="footer_title">
              {{ l.o_item_total_repayment_amount }}
            </div>
            <div class="footer_desc">NT${{ totalAmount }}</div>
          </div>
          <!--          <div class="footer_item" v-if="interest">-->
          <!--            <div class="footer_title">{{ l.o_item_daily_interest }}</div>-->
          <!--            <div class="footer_desc">${{ interest }}</div>-->
          <!--          </div>-->
          <div class="footer_item" v-if="interestRate">
            <div class="footer_title">{{ l.o_item_daily_interest }}</div>
            <div class="footer_desc">{{ interestRate }}</div>
          </div>
          <!--          <div class="footer_item" v-if="serviceFee">-->
          <!--            <div class="footer_title">-->
          <!--              {{-->
          <!--                l.o_item_service_fee-->
          <!--              }}-->
          <!--              <Icon-->
          <!--                  style="margin-left:6px;"-->
          <!--                  @click="isShowPopup = true"-->
          <!--                  name="warning-o"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div class="footer_desc">-${{ serviceFee }}</div>-->
          <!--          </div>-->
          <div class="footer_item" v-if="loanTerm">
            <div class="footer_title">{{ l.o_item_borrowing_cycle }}</div>
            <div class="footer_desc">{{ loanTerm }}{{ l.home_unit_day }}</div>
          </div>
          <div class="footer_item" v-if="releaseTime">
            <div class="footer_title">{{ l.o_item_borrowing_time }}</div>
            <div class="footer_desc">{{ releaseTime }}</div>
          </div>
          <div class="footer_item" v-if="applyTime">
            <div class="footer_title">{{ l.o_item_application_time }}</div>
            <div class="footer_desc">{{ applyTime }}</div>
          </div>
          <div class="footer_item" v-if="overdueTime && ![4,6].includes(order.loan_status)">
            <div class="footer_title">{{ l.o_item_expire_dead_date }}</div>
            <div class="footer_desc">{{ overdueTime }}</div>
          </div>
          <!--          <div class="footer_item" v-if="loanOverdueDay">-->
          <!--            <div class="footer_title">{{ l.o_item_days_overdue }}</div>-->
          <!--            <div class="footer_desc" :class="isRed && 'redColor'">-->
          <!--              {{ loanOverdueDay }}{{ l.home_unit_day }}-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="footer_item" v-if="clearedTime">
            <div class="footer_title">{{ l.o_item_clarify_time }}</div>
            <div class="footer_desc">{{ clearedTime }}</div>
          </div>
          <div
              class="footer_item"
              v-if="totalAmount && ['wyqhk', 'yqhk'].includes(orderDescIndex)"
          >
            <div class="footer_title">
              {{ l.o_item_total_repayment_amount }}
            </div>
            <div class="footer_desc">NT${{ totalAmount }}</div>
          </div>
          <div class="footer_item" v-if="repaymentAmount">
            <div class="footer_title">{{ l.o_item_repay_money }}</div>
            <div class="footer_desc">{{ repaymentAmount }}</div>
          </div>
          <div class="footer_item" v-if="accountName">
            <div class="footer_title">{{ l.o_item_income }}</div>
            <div class="footer_desc">{{ accountName }}</div>
          </div>
          <div class="footer_item" v-if="bank">
            <div class="footer_title">{{ l.o_item_beneficiary_bank }}</div>
            <div class="footer_desc">{{ bank }}</div>
          </div>
          <div class="footer_item" v-if="account">
            <div class="footer_title">{{ l.o_item_receiving_account }}</div>
            <div class="footer_desc">{{ account }}</div>
          </div>
          <div v-if="['fksb'].includes(orderDescIndex)" class="change_account" @click="changeAccount">
            {{ l.o_item_changeAccount }}
            <img class="change_account_img" src="@/assets/order/arrowright.png"/>
          </div>
        </div>
      </div>
    </div>

    <div v-if="orderDesc[orderDescIndex]" class="order_tips_desc" :class="orderDescIndex == 'fkz' && 'fkz'">
      <img class="order_tips_desc_img" src="@/assets/order/tips.png" alt="">
      <div class="order_tips_desc_text">{{ orderDesc[orderDescIndex] }}</div>
    </div>
    <CardPopup :show="isShowPopup" @closePopup="closePopup"
    >
      <div class="popupContainer">
        <div class="popupTitle">{{ l.home_service_fees_include }}:</div>
        <div class="popupDesc">
          <div class="popupItem">
            {{ l.home_payment_fee }}: {{ formatMoney(payAmount) }}
          </div>
          <div class="popupItem">
            {{ l.home_audit_consultation_fee }}:
            {{ formatMoney(serviceAmount) }}
          </div>
          <div class="popupItem">
            {{ l.home_handling_fee }}: {{ formatMoney(riskAmount) }}
          </div>
        </div>
      </div>
    </CardPopup>

    <Popup position="bottom" round v-model="showRepayment">
      <div class="popup_box">
        <img class="popup_box_close" @click="showRepayment = false" src="@/assets/home/guanbi2@2x.png" alt=""/>

        <div class="blocks">
          <div class="blocks_title">
            {{ l.rm_nav_title }}
          </div>
          <div class="repayment_method_box">
            <div v-if="order.repaymentMethods && order.repaymentMethods.includes('offline')"
                 @click="chooseRepaymentMethod(1)" class="repayment_method_item"
                 :class="repaymentMethod == 1 && 'repayment_method_item_select'">
              {{ l.home_transfer }}
            </div>
            <div v-if="order.repaymentMethods && order.repaymentMethods.includes('online')"
                 @click="chooseRepaymentMethod(2)" class="repayment_method_item"
                 :class="repaymentMethod == 2 && 'repayment_method_item_select'">
              {{ l.home_credit_card }}
            </div>

          </div>
        </div>

        <div class="btnBox">
          <Button
              @click="handleRepaymentBtn(1)"
              class="confirmLoanBtn"
              block
              type="info"
              native-type="submit"
          >{{ l.home_confirm_btn }}
          </Button>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import {Button, Icon, Popup} from "vant";
import {formatMoney} from "@/utils";
import l from "@/locales";
import CardPopup from "@/components/cardPopup";
import {loanappqueryDetail} from "@/services/order";
import {orderStatus} from "../../utils/maps";
import {config} from "@/services/user";

export default {
  name: "orderInfo",
  components: {Button, CardPopup, Icon, Popup},
  props: {
    busiId: {
      type: String,
    },
  },
  data() {
    return {
      l: {
        ...l.home,
        ...l.repayMethods,
        ...l.orderItem,
        ...l.other,
        ...l.tabbar,
      },
      orderStatus: orderStatus,
      backgroundImgs: [
        require("@/assets/order/shenhezhong.png"), //审核中 0
        require("@/assets/order/daihuankuan.png"), //待还款 1
        require("@/assets/order/dingdanquxiao.png"), //订单取消 2
        require("@/assets/order/fangkuanzhong.png"), //放款中 3
        require("@/assets/order/shenheshibai.png"), //审核失败 4
        require("@/assets/order/yijieqing.png"), //已结清 5
        require("@/assets/order/yuqi.png"), //逾期 6
      ],
      backgroundImgsIndex: -1,
      orderStatusIndex: -1,
      orderDesc: {
        qxdd: "", //取消订单提示
        shjj: "", //审核拒绝提示
        yjq: "", //已结清提示
        yqhk: "", //逾期还款提示
        wyqhk: "", //未逾期还款提示
        shz: "", //审核中提示
        fkz: "", //放款中提示
        fksb: "请核对收款账户是否正确", //放款失败提示
      },
      orderDescIndex: "",

      isShowBtnConfirm: false,
      isShowBtnConfirm2: false,
      isRed: false,

      repayAmount: "",
      interest: "",
      interestRate: "",
      loanAmount: "",
      serviceFee: "",
      loanTerm: "",
      bank: "",
      account: "",
      accountName: "",
      loanOverdueFee: "",
      loanFaleFee: "",
      loanOverdueDay: "",
      totalAmount: "",
      clearedTime: "",
      applyTime: "",
      processingDate: "",
      overdueTime: "",
      releaseTime: "",
      repaymentAmount: "",

      loanTitle: "",
      loanNumber: "",
      isShowPopup: false,
      riskAmount: undefined,
      payAmount: undefined,
      serviceAmount: undefined,
      order: {},
      isLoanAmount: true,
      isNewLoan: true,

      showRepayment: false,
      repaymentMethod: 1,
    };
  },
  watch: {
    busiId(val) {
      if (val) {
        this.getDetail();
      }
    },
  },
  created() {
    this.isNewLoan = localStorage.getItem("isNewLoan") == "1" ? true : false;
    this.getDetail();
  },
  methods: {
    formatMoney,
    async getDetail() {
      let loanappqueryDetails = await loanappqueryDetail({
        busiNo: this.busiId,
      });
      this.order = loanappqueryDetails.result;

      // this.order = {
      //   "amount2Account": "750,000.00",
      //   "app_time": "2024-02-22",
      //   "application_id": "VAL3020240222000086084",
      //   "apply_time": 1708583116000,
      //   "approval_time": "",
      //   "bankName": "DongA Joint Stock Commercial Bank (DONGABANK)",
      //   "bank_code": "970406",
      //   "bid_status": 1,
      //   "busiId": "VAL3020240222000086084",
      //   "card_holder": "NGUYỄN ĐÌNH VINH",
      //   "card_no": "265165165165",
      //   "chargeType": 10,
      //   "data_status": 2,
      //   "duration": "7",
      //   "extendProperties": "",
      //   "fee": 750000,
      //   "has_loan_app": true,
      //   "interest": 105000,
      //   "interestRate": 1,
      //   "loan_status": "2",
      //   "logo": "https://oss-vn-vay24.oss-cn-hongkong.aliyuncs.com/%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20231011105721.png",
      //   "mchId": 10061,
      //   "mchName": "Ví mặt trời",
      //   "pay": 300000,
      //   "payType": "mnf",
      //   "paymentAmount": "1,605,000.00",
      //   "principal": "1,500,000",
      //   "reApplyFace": false,
      //   "repayChannels": [
      //     "wePay"
      //   ],
      //   "repaymentKey": "xxx",
      //   "repaymentMethods": [
      //     "online"
      //   ],
      //   "repaymentTypes": [
      //     "normal",
      //     "rollover"
      //   ],
      //   "risk": 150000,
      //   "rollver": true,
      //   "secAppTime": 1708583132782,
      //   "service": 300000
      // };

      this.init();
    },
    closePopup() {
      this.isShowPopup = false;
    },
    getAmount() {
      let order = this.order;
      order.loan_status = Number(order.loan_status);
      order.bid_status = Number(order.bid_status);
      let amount;
      switch (order.loan_status) {
        case 2:
        case 3:
        case 5:
          amount = order.principal;
          break;
        case 1:
          amount = order.amount2Account;
          break;
        case 4:
        case 6:
          amount = order.remainAmount;
          break;
        case 9:
          amount = order.reach_amount;
          break;
      }
      if (amount.includes(",")) {
        amount = Number(amount.replace(/,/g, ""));
      }
      return amount;
    },
    changeAccount() {
      this.$router.push({path: "/bankCard", query: {busiId: this.busiId}})
    },
    chooseRepaymentMethod(val) {
      this.repaymentMethod = val;
    },
    openRepayModal() {
      this.repaymentMethod = 1;
      this.showRepayment = true;
    },
    handleRepaymentBtn(vaType) {
      this.order.vaType = vaType;
      // if (vaType == 1) {
      //   this.order.repaymentMed = this.repaymentMethod;
      // }
      this.$emit("handleRepaymentBtn", this.order);
    },
    handleBorrowAnotherStroke() {
      this.$router.push("/home");
    },
    init() {
      let order = this.order;
      this.isShowBtnConfirm = false;
      this.isRed = false;
      order.loan_status = Number(order.loan_status);
      order.bid_status = Number(order.bid_status);
      // order.loan_status = 2;
      switch (order.loan_status) {
        case 2: //审核中
          this.loanTitle = this.l.o_loan_loan_amounts;
          if (!this.isNewLoan) {
            this.loanTitle = this.l.o_loan_maximum_borrowing;
          }
          this.backgroundImgsIndex = 0;
          this.orderStatusIndex = 0;
          this.orderDescIndex = "shz";
          break;
        case 3: //拒绝
          this.loanTitle = this.l.o_loan_loan_amounts;
          if (!this.isNewLoan) {
            this.loanTitle = this.l.o_loan_maximum_borrowing;
          }
          this.backgroundImgsIndex = 4;
          this.orderStatusIndex = 1;
          this.orderDescIndex = "shjj";
          break;
        case 4: //未逾期
          this.loanTitle = this.l.o_item_borrowing_amount;
          this.backgroundImgsIndex = 1;
          this.orderStatusIndex = 6;
          this.isShowBtnConfirm = true;
          this.orderDescIndex = "wyqhk";
          break;
        case 5: //放款中
          this.loanTitle = this.l.o_loan_loan_amounts;
          this.backgroundImgsIndex = 3;
          this.orderStatusIndex = 3;
          this.orderDescIndex = "fkz";
          break;
        case 6: //逾期
          this.loanTitle = this.l.o_item_borrowing_amount;
          this.backgroundImgsIndex = 6;
          this.orderStatusIndex = 7;
          this.isShowBtnConfirm = true;
          this.isRed = true;
          this.orderDescIndex = "yqhk";
          break;
        case 9: //结清
          this.$router.push('/order');
          this.loanTitle = this.l.o_loan_repay_amount;
          this.backgroundImgsIndex = 5;
          this.orderStatusIndex = 5;
          this.orderDescIndex = "yjq";
          break;
        case 99: //待提现
          this.loanTitle = this.l.o_loan_loan_amounts;
          this.backgroundImgsIndex = 5;
          this.orderStatusIndex = 10;
          break;
        case 199: //退回
          this.loanTitle = this.l.o_loan_loan_amounts;
          this.backgroundImgsIndex = 5;
          this.orderStatusIndex = 9;
          break;
      }
      this.initData();
      if (order.bid_status == 6) {
        //     //放款失败
        this.loanTitle = this.l.o_loan_loan_amounts;
        this.backgroundImgsIndex = 3;
        this.orderStatusIndex = 4;
        this.orderDescIndex = "fksb";
      } else if (order.bid_status == 7) {
        this.loanTitle = this.l.o_loan_loan_amounts;
        if (!this.isNewLoan) {
          this.loanTitle = this.l.o_loan_maximum_borrowing;
        }
        this.backgroundImgsIndex = 2;
        this.orderStatusIndex = 2;
        this.orderDescIndex = "qxdd";
        this.isShowBtnConfirm2 = true;
      } else if (order.bid_status == 8) {
        if (order.data_status != 1) {
          this.loanTitle = this.l.o_loan_loan_amounts;
          this.backgroundImgsIndex = 4;
          this.backgroundImgsIndex = 1;
          this.orderDescIndex = "shjj";
        } else {
          this.isShowBtnConfirm2 = true;
        }
      }
    },
    async initData() {
      this.repayAmount = "";
      this.interest = "";
      this.loanAmount = "";
      this.serviceFee = "";
      this.loanTerm = ""; //天
      this.bank = "";
      this.account = "";
      this.accountName = "";
      this.loanOverdueFee = ""; //$
      this.loanFaleFee = ""; //$
      this.loanOverdueDay = ""; //天
      this.totalAmount = ""; //$
      this.clearedTime = "";
      this.applyTime = "";
      this.processingDate = "";
      this.overdueTime = "";
      this.releaseTime = "";
      this.loanNumber = "";

      let order = this.order;
      this.loanNumber = this.getAmount();
      this.repayAmount = order.amount;
      this.interest = order.interest;
      this.loanAmount = order.principal;
      this.serviceFee = order.fee;
      this.loanTerm = order.duration; //天
      this.bank = order.bankName;
      this.account = order.card_no;
      this.accountName = order.card_holder;

      this.riskAmount = order.risk;
      this.payAmount = order.pay;
      this.serviceAmount = order.service;
      if (order.penalty && order.penalty.includes(",")) {
        console.log("1111111111", Number(order.fale_fee.replace(/,/g, "")), Number(order.penalty.replace(/,/g, "")));
        this.loanOverdueFee =
            Number(order.penalty.replace(/,/g, "")) +
            Number(order.fale_fee.replace(/,/g, "")); //$
      }
      this.loanOverdueDay = order.penalty_days; //天
      this.totalAmount = order.paymentAmount; //$
      this.clearedTime = order.pay_time;
      this.applyTime = order.app_time;
      this.overdueTime = order.deposit_time;
      this.releaseTime = order.borrow_time;
      if (order.loan_status == 2) {
        this.releaseTime = "";
        this.bank = "";
        this.account = "";
        this.accountName = "";
        this.loanAmount = "";
        if (!this.isNewLoan) {
          this.totalAmount = "";
          this.serviceFee = "";
          this.interest = "";
          this.interestRate =
              order.interestRate + "%/" + this.l.o_details_unit_day;
          let conf = JSON.parse(localStorage.getItem("config") || "{}");

          if (!conf) {
            let res = await config();
            conf = res.result;
          }
          // console.log("conf", conf.result);
          this.loanNumber = conf.loan_max_amount;
        }
      }
      if (order.loan_status == 3) {
        this.loanAmount = "";
        this.releaseTime = "";
        this.bank = "";
        this.account = "";
        this.accountName = "";
        if (!this.isNewLoan) {
          this.totalAmount = "";
          this.serviceFee = "";
          this.interest = "";
          this.interestRate =
              order.interestRate + "%/" + this.l.o_details_unit_day;
          let conf = JSON.parse(localStorage.getItem("config") || "{}");

          if (!conf) {
            let res = await config();
            conf = res.result;
          }
          // console.log("conf", conf.result);
          this.loanNumber = conf.loan_max_amount;
        }
      }
      if (order.loan_status == 4) {
        //还款中
        this.applyTime = "";
        this.serviceFee = "";
        this.loanOverdueDay = "";
        this.bank = "";
        this.account = "";
        this.accountName = "";
        this.clearedTime = "";
        this.totalAmount = ""; //$
        // this.totalAmount = "";
      }
      if (order.loan_status == 5) {
        this.loanAmount = "";
        if (order.bid_status == 6) {
          this.applyTime = "";
          this.processingDate = order.app_time;
        }
      }
      if (order.loan_status == 6) {
        this.serviceFee = "";
        // this.releaseTime = "";
        this.applyTime = "";
        this.bank = "";
        this.account = "";
        this.accountName = "";
        this.clearedTime = "";
        this.totalAmount = ""; //$

        if (order.penalty) {
          this.loanOverdueFee = order.penalty; //$
        }

        if (order.fale_fee) {
          this.loanFaleFee = order.fale_fee; //$
        }
      }
      if (order.loan_status == 9) {
        this.serviceFee = "";
        this.releaseTime = "";
        // this.applyTime = "";
        this.bank = "";
        this.account = "";
        this.accountName = "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../views/index/confirm.less";

.orderInfo {
  height: auto;
  min-height: auto;

  .redColor {
    color: #e02020 !important;
  }

  .mainContent {
    margin: 0 20px;
    box-shadow: 0px 0px 5px 0px rgba(56, 151, 229, 0.2);

    .container {
      // padding: 0 15px;
      width: 100%;
      // box-sizing: border-box;

      .change_limit_con {
        position: relative;
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #333333;
        box-sizing: border-box;

        width: 100%;
        background: #ffffff;
        border-radius: 13px 13px 0 0;

        .orderNesc {
          display: flex;
          align-items: center;
          justify-content: space-between;

          width: 100%;
          box-sizing: border-box;

          height: 62px;
          padding: 16px 20px;
          padding-right: 0;

          .orderMerchant {
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .orderMerchantImg {
              width: 30px;
              height: 30px;
              background: #E9EDF1;

              border-radius: 50%;
              margin-right: 12px;
            }

            .orderMerchantName {
              font-size: 14px;
              font-family: PingFangSC, PingFang SC;
              font-weight: 500;
              color: #28435B;

            }
          }

          .orderDetail {
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #45A1FF;

            .orderDetail_icon {
              font-size: 20px;
              display: none;
            }

            .orderItem {
              .orderStatus {
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #45A1FF;
                width: 120px;
                min-height: 28px;
                background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #D2E3F7 100%);


                display: flex;
                align-items: center;
                justify-content: flex-end;
                text-align: center;

                //padding-left: 66px;
                padding-right: 15px;
                box-sizing: border-box;
              }


              .red {
                color: #EC1E1E;
                background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #FCDBDB 100%);
              }
            }
          }
        }

        .applyImg {
          width: 103px;
          height: 74px;
        }

        .order_header_box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 40px;
          box-sizing: border-box;

          border-top: 1px solid #DDE3E9;
        }

        .order_title {
          text-align: center;
          width: fit-content;
          box-sizing: border-box;

          font-size: 12px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #959DA8;

        }

        .order_status {
          text-align: center;
          width: 150px;
          padding: 8px 16px;
          box-sizing: border-box;

          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #28435B;
        }

        .green {
          //color: #1cbd26;
        }

        .red {
          color: #EC1E1E;
        }

        .order_amount {
          font-size: 16px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          color: #28435B;
          margin-top: 6px;

        }

        .order_desc {
          position: absolute;
          top: 128px;
          left: 20px;
          z-index: 1;

          width: 176px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #28435B;
          line-height: 20px;
        }

        .order_desc_bgc {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;

          height: 74px;

          background: #F8FBFF;
          border-radius: 0px 0px 13px 13px;
          opacity: 0.8;
        }

        .fkz {
          top: 130px;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }

    .button_font_box {
      margin-top: 6px;
      padding: 0 35px;
      padding-bottom: 12px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .button_font {
      margin: 0 auto;
      //margin-bottom: 16px;

      border: none;

      width: 100%;
      border-radius: 21px;

      padding: 6px;
      box-sizing: border-box;
      height: 35px;
      background: rgba(16, 103, 219, 0.1);
      border: 1px solid #2980F6;

      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 15px;
      color: #2980F6;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .orderInfo_round_box {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 18px;
      background: url("~@/assets/order/round.png") no-repeat;
      background-size: 100% 100%;
    }

    .container_info {
      //margin-bottom: 8px;
      box-sizing: border-box;
      padding: 6px 20px;

      width: 100%;
      border-radius: 0 0 12px 12px;
      background: #FFFFFF;

      .info_footer {
        .footer_item {
          display: flex;
          margin: 10px 0;

          .footer_title {
            flex: 1;
            margin-right: 10px;
            display: flex;
            align-items: center;

            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #859BAE;

          }

          .footer_desc {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            text-align: right;

            font-size: 14px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #4B6880;

          }

          .footer_desc_red {
            color: #EC1E1E;
          }
        }

        .change_account {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #3387F8;

          margin-top: 6px;
          margin-bottom: 20px;

          .change_account_img {
            width: 16px;
            height: 16px;
            margin-left: 5px;
          }
        }
      }

      .limit_footer {
        display: flex;
        justify-content: space-between;

        .footer_item {
          // flex: 1;
          .footer_item_title {
            font-size: 12px;
            color: #a3a3a3;
          }

          span {
            font-size: 14px;
            color: #3a3a3a;
          }

          &:nth-child(1) {
            // text-align: right;
            width: 50%;
            border-right: 1px solid #ababab;
          }
        }

        .footer_item_center {
          width: 1px;
          background: #ababab;
        }
      }
    }

    .container_info_middle {
      border-radius: 0;
    }
  }

  .order_tips_desc {
    padding: 0 20px;
    margin-top: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;

    .order_tips_desc_img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }

    .order_tips_desc_text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 13px;
      color: #445144;
    }
  }
}


.popup_box {
  position: relative;

  .popup_box_close {
    position: absolute;
    top: 20px;
    right: 20px;
    width: 14px;
    height: 14px;
    z-index: 10;
  }


  .btnBox {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;

    .confirmLoanBtn {
      margin: 0 auto;
      border: none;

      width: calc(100% - 100px);

      height: 48px;
      background: linear-gradient(180deg, #A5D1FA 0%, #3F8FFB 100%);
      border-radius: 21px;

      font-size: 16px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;

    }
  }

  .blocks {
    position: relative;
    margin-bottom: 10px;
    padding: 0 20px;
    padding-top: 50px;
    box-sizing: border-box;

    background: #ffffff;
    border-radius: 12px;

    .blocks_title {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #000000;
      text-align: center;
    }

    .repayment_method_box {
      padding: 0 30px;
      box-sizing: border-box;
      margin-top: 30px;

      .repayment_method_item {
        margin-top: 15px;
        width: 100%;
        height: 48px;
        background: #EBEBEB;
        border-radius: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #666666;

      }

      .repayment_method_item_select {
        border: 1px solid #2980F6;
        color: #2980F6;
        pointer-events: none;
      }
    }

  }
}
</style>
